import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    createAccountLateFeePolicy: {
        method: 'PUT',
        url: `${BASE_PATH_API}/account/lateFeePolicy`
    },
    getAccountLateFeePolicy: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/lateFeePolicy`
    },
    createRentalPropertyOrAssociationLateFeePolicy: {
        method: 'PUT',
        url: `${BASE_PATH_API}/properties/:id/lateFeePolicy`
    },
    getRentalPropertyOrAssociationLateFeePolicy: {
        method: 'GET',
        url: `${BASE_PATH_API}/properties/:id/lateFeePolicy`
    },
    deleteRentalPropertyOrAssociationLateFeePolicy: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/properties/:id/lateFeePolicy`
    },
    createLeaseLateFeePolicy: {
        method: 'PUT',
        url: `${BASE_PATH_API}/leases/:id/lateFeePolicy`
    },
    getLeaseLateFeePolicy: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:id/lateFeePolicy`
    },
    deleteLeaseLateFeePolicy: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/leases/:id/lateFeePolicy`
    },
    getLateFeePolicySummaryForProperty: {
        method: 'GET',
        url: `${BASE_PATH_API}/properties/:id/lateFeeSummary`
    },
    getLateFeePolicySummaryForLease: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:id/lateFeeSummary`
    }
};

export function LateFeePolicyApi() {
    return createActions(actions);
}
